import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { login } from "../api";
import { ErrorMessage } from "../components/sso/error_message";
import { LoginForm } from "../components/sso/login_form";
import { OrgSelect } from "../components/sso/org_select";
import { OrgWrapper } from "../components/sso/org_wrapper";
import { Paragraph } from "../components/sso/paragraph";
import { SubmitButton } from "../components/sso/submit_button";
import { Title } from "../components/sso/title";
import { LoginStore } from "../store/login";
import { OrgAPI } from "src/api";
import { OrgStore } from "src/store";
import { getQueryParam } from "src/utils";

const OrgPicker = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(LoginStore.sliceSelectors.select());
  const { email, tokenUUID } = data;
  const orgs = useSelector(OrgStore.selectors.selectAll());
  const orgOptions = orgs.map((org) => ({ label: org.name, value: org.id }));

  useEffect(() => {
    const orgIdentifier = getQueryParam("short_name");
    if (orgIdentifier) {
      dispatch(OrgAPI.fetchOrgs({ orgIdentifier }));
    }
  }, [dispatch]);

  const onFormSubmit = () => ({ org }) => {
    dispatch(LoginStore.actions.setLoading());
    const selectedOrg = orgs.find((o) => o.name === org.label);

    // There are two ways to get to this page:
    // 1. User used the email/password login flow but multiple users were returned (the response will contain a tokenUUID).
    // 2. User used the SSO login flow but did not know their org ID
    if (tokenUUID) {
      dispatch(
        login({
          email,
          "org-id": selectedOrg.id,
          "token-uuid": tokenUUID,
        }),
      );
    } else {
      history.push(`/org/${selectedOrg.short_name}`);
    }
  };

  const text =
    "It looks like you have access to multiple organizations. Please select the organization you would like to sign in to.";

  if (!orgs.length) return null;

  return (
    <OrgWrapper>
      <Title text="Select an Organization to Sign In to" />
      <Paragraph text={text} />
      <LoginForm onSubmit={onFormSubmit}>
        <OrgSelect orgOptions={orgOptions} />
        <SubmitButton loading={loading} text="Continue" />
        {error ? <ErrorMessage msg={error} /> : null}
      </LoginForm>
    </OrgWrapper>
  );
};

export { OrgPicker };
